var exports = {
  "kL": "x52a3aa3b--28a506--container",
  "AV": "x52a3aa3b--28a506--desktop-only",
  "eb": "x52a3aa3b--28a506--fade-out",
  "iE": "x52a3aa3b--28a506--wrapper",
  "Qq": "x52a3aa3b--28a506--text",
  "z6": "x52a3aa3b--28a506--agreement",
  "VN": "x52a3aa3b--28a506--close",
  "lP": "x52a3aa3b--28a506--adaptive",
};

module.exports = exports;
